// extracted by mini-css-extract-plugin
export default {"authLayout":"AuthLayout_authLayout__42E7-","authHeaderLogo":"AuthLayout_authHeaderLogo__YYzC+","authLayoutContent":"AuthLayout_authLayoutContent__ZvxoJ"};